import { Link } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../../../context";

type Props = {
	link: string;
	title: string;
};

export default function LinkComponent({ link, title }: Props) {
	const { theme } = useContext(Context);
	const { translate } = useLocales();

	return (
		<Link
			href={link}
			rel='noopener'
			color={theme?.colors.primary}
			sx={{
				"&:hover": {
					textDecoration: "underline"
				}
			}}
			target='_blank'
			underline='none'
		>
			{translate(title)}
		</Link>
	);
}
